/* eslint-disable new-cap */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import React, {useMemo, useState} from 'react';
import {Button, Confirm, Popup} from 'semantic-ui-react';
import {DefaultColumnFilter} from '../internalCommons/TableFilters';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import CurrencyInput from 'react-currency-input-field';
import {destinyValues, stateRegisterValues} from '../../constants';
import {CustomDropDown} from '../internalCommons/customDropDown';
import CommercialTable from '../../../common/components/commercialTable/commercialTable';
import {dealersToArray, generateShipmentDropdown, mapDealersToDropdownList} from '../utils';
import {labelDateFormat} from '../../../common/constants/datesFormat';
import moment from 'moment';

const blockedRowFloatMessage = 'No se puede modificar. Este vehículo ya tiene una reserva en el inventario flotante.';
const blockedRowMessage = 'No se puede editar esta línea dado que se encuentra en proceso de liquidación.';
const blockedRowCIFMessage = 'No se puede editar esta línea dado que no tiene C&F.';

const handleInputText = ({row, data, handleChange}, value, keyValue) => {
  const newData = [...data];
  Object.assign(newData[row.index], {[keyValue]: value});
  handleChange({...newData[row.index]});
};

export const originsTableHeaderWithProps = ({listDealers, handleChange, data, shipmentsNumber, dealersRuc,
  handleConfirmationModal}) => {
  return [
    {
      'Header': () => <span className="header-title">NO. LÍNEA</span>,
      'title': 'NO. LÍNEA',
      'accessor': 'line',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">PEDIDO</span>,
      'title': 'PEDIDO',
      'accessor': 'orderNumber',
      'width': 150,
    
    
    },
    {
      'Header': () => <span className="header-title">ORDEN NO.</span>,
      'title': 'ORDEN NO.',
      'accessor': 'item',
      'width': 150,
    
    
    },
    {
      'Header': () => <span className="header-title">SFX</span>,
      'title': 'SFX',
      'accessor': 'sfx',
      'width': 150,
    
    
    },
    {
      'Header': () => <span className="header-title">MODELO (KATASHIKI)</span>,
      'title': 'MODELO (KATASHIKI)',
      'accessor': 'master',
      'width': 250,
    
    },
    {
      'Header': () => <span className="header-title">DESCRIPCIÓN</span>,
      'title': 'DESCRIPCIÓN',
      'accessor': 'model',
      'width': 250,
    
    },
    {
      'Header': () => <span className="header-title">COLOR EXTERNO</span>,
      'title': 'COLOR EXTERNO',
      'accessor': 'externalColor',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">CÓDIGO EXTERNO</span>,
      'title': 'CÓDIGO EXTERNO',
      'accessor': 'externalColorId',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">COLOR INTERNO</span>,
      'title': 'COLOR INTERNO',
      'accessor': 'internalColor',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">CÓDIGO INTERNO</span>,
      'title': 'CÓDIGO INTERNO',
      'accessor': 'internalColorId',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">CHASIS</span>,
      'title': 'CHASIS',
      'accessor': 'chassis',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">MOTOR</span>,
      'title': 'MOTOR',
      'accessor': 'motor',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">RAMV</span>,
      'title': 'RAMV',
      'accessor': 'ranmv',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">AÑO MODELO</span>,
      'title': 'AÑO MODELO',
      'accessor': 'year_model',
      'width': 250,
      'Cell': ({row}) => {
        const blockField = row.original.editable === 'N';
        if (row.original.register_state === 'I') {
          return <span>{row.original.year_model}</span>;
        }
        return (
          <Popup
            trigger={
              <span>
                <div className='ui input input-price'>
                  <CurrencyInput
                    disabled={blockField}
                    className={`custom-input-small ${blockField && 'disabled-custom'}`}
                    value={row.original.year_model || ''}
                    onValueChange={(value, name) =>
                      parseInt(value) &&
                        handleInputText({row, handleChange, data}, value, 'year_model')
                    }
                  />
                </div>
              </span>
            }
            content={blockedRowMessage}
            position='top center'
            size='small'
            style={{'marginBottom': '20px'}}
            disabled={!blockField}
            inverted
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">ETD</span>,
      'title': 'ETD',
      'accessor': 'dateOfShipmentText',
      'width': 250,
    
    },
    {
      'Header': () => <span className="header-title">ETA</span>,
      'title': 'ETA',
      'accessor': 'dateOfArrivalText',
      'width': 250,
    
      'Cell': ({row}) =>
        <span>{row.original.etaTrackingDate || row.original.dateOfArrivalText}</span>,
    },
    {
      'Header': () => <span className="header-title">EMBARQUE</span>,
      'title': 'EMBARQUE',
      'accessor': 'shipmentText',
      'width': 150,
      'Cell': ({row}) => {
        const blockField = row.original.editable === 'N' || !row.original.cif;
        if (row.original.register_state === 'I') {
          return <span>{row.original.shipmentText}</span>;
        }
        return (
          <Popup
            trigger={
              <span>
                <CustomDropDown
                  disabled={blockField}
                  className='show-orders-table-dropdown'
                  options={generateShipmentDropdown(shipmentsNumber)}
                  value={row.original.shipment || null}
                  onChange={(e, {value}) =>
                    handleInputText(
                      {row, handleChange, data},
                      value,
                      'shipment'
                    )
                  }
                />
              </span>
            }
            content={!row.original.cif ? blockedRowCIFMessage : blockedRowMessage}
            position='top center'
            size='small'
            style={{'marginBottom': '20px'}}
            disabled={!blockField}
            inverted
          />
        );
      },
    
    },
    {
      'Header': () => <span className="header-title">FACTURA ORIGEN</span>,
      'title': 'FACTURA ORIGEN',
      'accessor': 'invoiceNumber',
      'width': 200,
    
    },
    {
      'Header': () => <span className="header-title">UBICACIÓN</span>,
      'title': 'UBICACIÓN',
      'accessor': 'location',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">ASIGNADO A</span>,
      'title': 'ASIGNADO A',
      'accessor': 'dealer_name',
      'width': 200,
      'Cell': ({row}) => {
        if (row.original.register_state === 'I') {
          return <span>{row.original.dealer_name}</span>;
        }
        return (
          <CustomDropDown
            disabled={row.original?.floatingVisible === 'S'}
            className='show-orders-table-dropdown'
            options={listDealers}
            value={row.original.dealer_id}
            onChange={(e, {value}) => handleConfirmationModal(
              {row, handleChange, data},
              value,
              'dealer_id'
            )
            }
          />
        );
      },
    
    },
    {
      'Header': () => <span className="header-title">OBSERVACIONES</span>,
      'title': 'OBSERVACIONES',
      'accessor': 'observations',
      'Cell': ({row}) => (
        <>
          <Popup
            trigger={
              <div className="dot">
                {row.original?.observations?.length || 0}
              </div>
            }
            position="top center"
            size="small"
            className="observations-popup"
            disabled={!row?.original?.observations?.length}
            inverted
          >
            <Popup.Header>Modificaciones en "Asignado A"</Popup.Header>
            <Popup.Content style={{'fontSize': '9px'}}>
              <table>
                {row?.original?.observations?.map((observation, index) => (
                  <tr>
                    <th>{moment(observation.arrivalDate).format(labelDateFormat)}:</th>
                    <th>{observation.dealerNameOld}</th>
                    <th>&rarr;</th>
                    <th>{observation.dealerNameNew}</th>
                  </tr>
                ))}
              </table>
            </Popup.Content>
          </Popup>
        </>
      ),
    },
    {
      'Header': () => <span className="header-title">CLIENTE</span>,
      'title': 'CLIENTE',
      'accessor': 'clientName',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">RUC/CI CLIENTE</span>,
      'title': 'RUC/CI CLIENTE',
      'accessor': 'clientId',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">IMPORTADOR</span>,
      'title': 'IMPORTADOR',
      'accessor': 'importer',
      'width': 150,
      'Cell': ({row}) => {
        if (row.original.register_state === 'I' || !dealersRuc.includes(row.original.importerId)) {
          return <span>{row.original.importer}</span>;
        }
        return (
          <CustomDropDown
            disabled={row.original?.editable === 'N'}
            className='show-orders-table-dropdown'
            options={listDealers}
            value={row.original.importerId}
            onChange={(e, {value}) =>
              handleInputText(
                {row, handleChange, data},
                value,
                'importerId'
              )
            }
          />
        );
      },
    
    },
    {
      'Header': () => <span className="header-title">DESTINO</span>,
      'title': 'DESTINO',
      'accessor': 'destinyText',
      'width': 150,
      'Cell': ({row}) => {
        const blockFloating = ['FL', 'DE', 'DN'].includes(row.original.destiny) && ['R', 'S', 'L', 'V'].includes(row.original.floatingState);
        const popUpMessage = blockedRowFloatMessage;
        if (row.original.register_state === 'I') {
          return <span>{row.original.destinyText}</span>;
        }
        return (
          <Popup
            trigger={
              <span>
                <CustomDropDown
                  disabled={blockFloating}
                  className={'custom-input-small'}
                  value={row.original.destiny}
                  onChange={(e, {value}) =>
                    handleInputText(
                      {row, handleChange, data},
                      value,
                      'destiny'
                    )
                  }
                  options={destinyValues}
                />
              </span>
            }
            content={popUpMessage}
            position='top center'
            size='small'
            style={{'marginBottom': '20px'}}
            disabled={!blockFloating}
            inverted
          />
        );
      },
    
    },
    {
      'Header': () => <span className="header-title">C & F</span>,
      'title': 'C & F',
      'accessor': 'cif',
      'width': 150,
      'className': 'width-order-small cell-custom',
      'Cell': ({row}) => {
        const blockField = row.original.editable === 'N';
        if (row.original.register_state === 'I') {
          const dollarUS = Intl.NumberFormat('de-DE');

          return <span>{`$ ${dollarUS.format(row.original.cif)}`}</span>;
        }
        return (
          <Popup
            trigger={
              <span>
                <div className='ui input input-price'>
                  <CurrencyInput
                    disabled={blockField}
                    className={`custom-input-small ${blockField && 'disabled-custom'}`}
                    prefix="$ "
                    decimalSeparator=","
                    groupSeparator="."
                    decimalsLimit={2}
                    value={row.original.cif || ''}
                    onValueChange={(value, name) =>
                      parseFloat(value) < 100000.00 &&
                        handleInputText({row, handleChange, data}, parseFloat(value), 'cif')
                    }
                  />
                </div>
              </span>
            }
            content={blockedRowMessage}
            position='top center'
            size='small'
            style={{'marginBottom': '20px'}}
            disabled={!blockField}
            inverted
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'title': 'ESTADO',
      'accessor': 'state_text',
      'width': 150,
    
    },
    {
      'Header': () => <span className="header-title">ESTADO DE REGISTRO</span>,
      'title': 'ESTADO DE REGISTRO',
      'accessor': 'register_state',
      'width': 150,
      'Cell': ({row}) => {
        const blockField = row.original.editable === 'N';
        return (
          <Popup
            trigger={
              <span>
                <CustomDropDown
                  disabled={blockField || parseInt(row.original.shipment, 10)}
                  className={`custom-input-small ${(blockField || row.original.shipment) && 'disabled-custom'}`}
                  value={row.original.register_state}
                  onChange={(e, {value}) =>
                    handleInputText(
                      {row, handleChange, data},
                      value,
                      'register_state'
                    )
                  }
                  options={stateRegisterValues}
                />
              </span>
            }
            content={blockedRowMessage}
            position='top center'
            size='small'
            style={{'marginBottom': '20px'}}
            disabled={!blockField}
            inverted
          />
        );
      },
    
    },
  ];
};


const ShowOrdersTable = ({
  dataTable,
  handleChange,
  listDealers,
  updateTable,
  shipmentsNumber,
  setFilteredData,

}) => {
  const [confirmationModal, setConfirmationModal] = useState({
    'show': false,
    'row': null,
    'data': null,
    'value': null,
    'keyValue': null,
  });
  const handleConfirmationModal = ({row, data, handleChange}, value, keyValue) => {
    if (row.original.destiny !== 'NL') {
      setConfirmationModal({
        'show': true,
        'row': row,
        'data': data,
        'value': value,
        'keyValue': keyValue,
      });
    } else {
      handleInputText({row, data, handleChange}, value, keyValue);
    }
  };
  const confirmModal = (e) => {
    e.preventDefault();
    const {row, data, value, keyValue} = confirmationModal;
    handleInputText({row, data, handleChange}, value, keyValue);
    setConfirmationModal({...confirmationModal, 'show': false});
  };

  const clone = cloneDeep(dataTable);
  const dealersRuc = useMemo(() => dealersToArray(listDealers), [listDealers]);

  const columnsTable = originsTableHeaderWithProps({
    'listDealers': mapDealersToDropdownList(listDealers),
    'data': clone,
    handleChange,
    shipmentsNumber,
    handleConfirmationModal,
    dealersRuc,
  });
  const data = useMemo(() => clone, [updateTable, shipmentsNumber]);
  const columns = useMemo(() => columnsTable, [updateTable, shipmentsNumber]);
  const fixedColumns = [50, 95, 100, 50, 130, 200];
  return (
    <>
      <CommercialTable
        columns={columns}
        data={data}
        defaultColumnFilter={DefaultColumnFilter}
        setFilteredData={setFilteredData}
        fixedColumns={fixedColumns}
        tableWrapperStyles={'show-order-table'}
        isSmallCell={true}
        tableType={'fixed'}
        lineColor={['rgb(255, 255, 255)']}
        colorLineByProperty={{'key': 'state', 'values': ['L', 'V'], 'rgbColor': 'rgb(157, 172, 191)'}}
      />
      <Confirm open={confirmationModal.show} content={'¿Está seguro que desea modificar el dealer asignado?'}
        onCancel={() => setConfirmationModal({...confirmationModal, 'show': false})}
        confirmButton={<Button primary content='Confirmar' onClick={(e) => confirmModal(e)} />}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  'listDealers': state.dealer.list,
  'updateTable': state.manageOrders.updateTable,
  'originsAllData': state.manageOrders.originsAllData,
});

const {fetchOrigins} = Actions;

export default connect(mapStateToProps, {
  fetchOrigins,
})(ShowOrdersTable);
